import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { map } from 'rxjs/operators';


@Injectable()
export class CodesService {

  private _urlCode: string = '/api/codes/';

    constructor(private http: HttpClient, private authService: AuthService) { }

    getCommunes(forceRefresh : boolean): any {
        console.log('get communes');
        if (forceRefresh == false) {
            return this.http.get('/api/observable')
                .pipe(map(result => {
                    let communes = localStorage.getItem('gapCommunes');
                    if (communes != null) {
                        communes = JSON.parse(communes);
                        return communes;
                    }
                    return [];
                }));
        }
        let cleSession = this.authService.getCleSession();
        return this.http.get<any>(this._urlCode +'communes/'+cleSession)
            .pipe(map(communes => {
                for (var i = 0; i < communes.length; i++) {
                    communes[i].CodeLocalite = communes[i].Code + ' ' + communes[i].Localite;
                }
                localStorage.setItem( 'gapCommunes', JSON.stringify(communes) );
                return communes;
            }));
    }

    getCodesPrestation(): any {
        return this.http.get<any>(this._urlCode +'CodesPrestation')
            .pipe(map(codes => {
                return codes.CodesPrestation;
            }));
    }

    getMaladie(clePersonnel : number): any{
      return this.http.get<any>(this._urlCode + 'MaladieAccident?clepersonnel='+clePersonnel)
        .pipe(map(maladies => {
          return maladies.MaladieAccident;
        }))
    }
  }
